import VideoAnanta from "./VideoAnanta";
import BukuAnanta from "./BukuAnanta";
import "./Home.scss";
import { createContext, useState, useEffect, useRef } from "react";

export const anantaContext = createContext();

const Home = () => {
  const [click, setClick] = useState();
  const [end, setEnd] = useState();

  function getCurrentDimension(){
    return {
      	width: window.innerWidth,
      	height: window.innerHeight
    }
  }

  const [screenSize, setScreenSize] = useState(getCurrentDimension());

  // MODAL
  const [modal, setModal] = useState(false);

  const Modal = useRef(null);

  // HANLDE CLOSE MODAL
  useEffect(() => {
      const handleClickRemoveModal = (event) => {
          if (!modal == false) {
              if (Modal.current) {
                  setModal(false);
              }
          }
      };
      document.addEventListener("click", handleClickRemoveModal, true);
      return () => {
          document.removeEventListener("click", handleClickRemoveModal, true);
      };
  }, [modal]);

  useEffect(() => {
    if(screenSize.width < 810) {
      setModal(true);
    }
  }, []);

  return (
    <anantaContext.Provider value={{ click, setClick, end, setEnd }}>
      <div id="Home">
        <VideoAnanta />
        <BukuAnanta />
        {modal ?
            <div ref={Modal} id="comingsoon" className="comingsoon" style={{
              background: "#321D19",
              opacity: "89%",
            }}>
                <div className="modal-content" style={{
                  padding: "0 16px",
                  fontFamily: "DM Sans",
                  display: "flex",
                  gap: "12px",
                  flexDirection: "column",
                  textAlign: "center",
                  fontSize: "22px",
                  justifySelf: "center",
                  top: "50%"
                }}>
                  <p style={{
                    fontSize: "20px",
                    marginBottom: "20px"
                  }}>Hai Pejuang Kupu - Kupu Bidadari!</p>
                  <p>Guna mendapatkan pengalaman terbaik, kami segenap tim produksi Ananta menyarankan teman-teman untuk mengakses situs pameran ini dengan menggunakan <span style={{ fontStyle: 'italic' }}>device PC/Laptop.</span></p>
                  <span style={{
                    fontSize: "16px",
                    marginTop: "100px",
                    opacity: "80%"
                  }}>Ketuk layar untuk melanjutkan!</span>
                </div>
            </div>
        : null}
      </div>
    </anantaContext.Provider>
  );
};

export default Home;
